(function () {
  const popup = document.getElementById('NewsletterPopup');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'np-newsletter-popup-dismissed';
  const delayMs = Math.max(0, Number(popup.dataset.delay || 3) * 1000);
  const hideDays = Math.max(1, Number(popup.dataset.hideDays || 14));
  const forceOpen = popup.dataset.forceOpen === 'true';
  const showOnMobile = popup.dataset.showMobile !== 'false';
  const overlay = popup.querySelector('[data-newsletter-popup-overlay]');
  const closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');
  const focusTarget = popup.querySelector('input[type="email"], button, [href]');
  let openTimer = null;
  let previouslyFocused = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isDismissed() {
    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return false;
      const until = Number(raw);
      if (!until || Number.isNaN(until)) return false;
      if (Date.now() > until) {
        localStorage.removeItem(storageKey);
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function rememberDismiss() {
    try {
      const until = Date.now() + hideDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(storageKey, String(until));
    } catch (error) {
      // Ignore storage errors (private mode, etc.)
    }
  }

  function isContactPopupOpen() {
    const cpPopup = document.getElementById('ContactPopup');
    return cpPopup ? cpPopup.classList.contains('is-open') : false;
  }

  function openPopup() {
    if (popup.classList.contains('is-open')) return;
    // Close contact popup first if it's open, then open newsletter
    const cpPopup = document.getElementById('ContactPopup');
    if (cpPopup && cpPopup.classList.contains('is-open')) {
      cpPopup.classList.remove('is-open');
      cpPopup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cp-popup-open');
    }
    previouslyFocused = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('np-newsletter-popup-open');
    window.setTimeout(() => focusTarget?.focus(), 50);
  }

  function closePopup(persist) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('np-newsletter-popup-open');
    if (persist) rememberDismiss();
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function shouldShow() {
    if (!showOnMobile && isMobile()) return false;
    if (forceOpen) return true;
    return !isDismissed();
  }

  function scheduleOpen() {
    if (!shouldShow()) return;
    openTimer = window.setTimeout(openPopup, forceOpen ? 0 : delayMs);
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup(true));
  });

  overlay?.addEventListener('click', () => closePopup(true));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup(true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleOpen);
  } else {
    scheduleOpen();
  }

  window.addEventListener('pagehide', () => {
    if (openTimer) window.clearTimeout(openTimer);
  });
})();
